/**
 * TibiMedia Customer API
 *
 * Contact: administratie@tibimedia.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderLineOption } from './orderLineOption';
import { OrderState } from './orderState';


/**
 * Represents a product line in an order.   Example with standalone product (has price and options with pricing): ```json {   \"id\": 23,   \"name\": \"Woonfotografie\",   \"icon\": \"fa-camera\",   \"state\": \"completed\",   \"price\": 150.00,   \"isPartOfPack\": false,   \"isEligibleForMessaging\": true,   \"customerUpload\": \"required\",   \"options\": [     {       \"name\": \"Extra Photos\",       \"price\": 25.00     },     {       \"name\": \"Rush Delivery\",       \"price\": 50.00     }   ] } ```  Example with pack product (no price, part of pack): ```json {   \"id\": 24,   \"name\": \"Energy Certificate\",   \"icon\": \"fa-certificate\",   \"state\": \"in_progress\",   \"price\": null,   \"isPartOfPack\": true,   \"isEligibleForMessaging\": true,   \"options\": [] } ```  Example with administrative product (not eligible for messaging): ```json {   \"id\": 25,   \"name\": \"Administrative Fee\",   \"icon\": \"fa-file\",   \"state\": \"completed\",   \"price\": 10.00,   \"isPartOfPack\": false,   \"isEligibleForMessaging\": false,   \"options\": [] } ``` 
 */
export interface OrderLine { 
    id?: number;
    name?: string;
    icon?: string;
    state?: OrderState;
    /**
     * Price for this order line. Null if the line is part of a pack.
     */
    price?: number | null;
    /**
     * Indicates whether this order line is part of a pack
     */
    isPartOfPack?: boolean;
    /**
     * Indicates whether this product is eligible for creating message threads. Administrative products are not eligible for messaging.
     */
    isEligibleForMessaging?: boolean;
    /**
     * Indicates whether customer file uploads are enabled for this suborder, derived from the product\'s customer_upload setting. When \"optional\" or \"required\", the frontend should enable uploading for this suborder. Omitted when uploads are disabled or not configured.
     */
    customerUpload?: OrderLineCustomerUploadEnum;
    options?: Array<OrderLineOption>;
}
export enum OrderLineCustomerUploadEnum {
    Optional = 'optional',
    Required = 'required'
};



